import styled from 'styled-components'

export const ReportContainer = styled.div`
  width: auto;
  height: auto;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  margin-top: 20px;
  padding-bottom: 10px;
  box-shadow: 0px 13px 42px 4px rgba(201,201,201,1);
  margin-bottom: 20px;
  @media (max-width: 760px) {
    width: 400px;
  }
`
export const Container = styled.div`
  width: 648px;
  height: 400px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  margin-top: 20px;
  padding-bottom: 10px;
  box-shadow: 0px 13px 42px 4px rgba(201,201,201,1);
  margin-bottom: 20px;
  @media (max-width: 760px) {
    width: 400px;
    height: auto;
  }
`

export const LoadingContainer = styled.div`
  width: 648px;
  height: 400px;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 760px) {
    width: 400px;
    height: 300px;
  }
`
export const ReportHeader = styled.div`
  height: 70px;
  width: auto;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  background-color: #4A90E2;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #FFFFFF;
  font-weight: bold;
`
export const TableHeader = styled.div`
  margin: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  font-size: 14px;
  line-height: 20px;
  padding: 14px;
  font-weight: 700;
  height: 100%;
  text-align: left;
  background: #F4F6F8;
  color: #637381;
`

export const TableContainer = styled.div`
  width: 648px;
  @media (max-width: 760px) {
    width: 400px;
  }
`
export const CellContainer = styled.div`
  display: flex;
  word-break: normal;
  justify-content: ${props => props.center ? 'center' : 'flex-start'};
  align-items: center;
  background-color:#FFFFFF;
  height: auto;
  padding: 14px;
  white-space: normal;
  font-size: 13px;
`

export const Export = styled.div`
  display: flex;
  width: 100%;
  height: 40px;
  justify-content: ${props => props.detail ? 'space-between' : 'flex-end'};
  align-items: center;
  color: red;
  border-top: solid 1px #CCCCCC;
  padding: 10px;
  box-sizing: border-box;
`



// WEBPACK FOOTER //
// ./src/Components/ReportsComponents/index.jsx